<template>
  <el-container v-loading="isLoading" class="Edit">
    <el-header class="Edit-header">
      <el-page-header @back="close" :content="title"></el-page-header>
    </el-header>
    <el-main class="Edit-main">
      <el-form :model="form" :rules="rules" ref="form" label-width="200px">
        <el-form-item v-if="isSspUser" label="所属广告主" prop="advertiserId">
          <el-select v-model="form.advertiserId" :disabled="isModel===2" @change="form.putUnitName='';form.planId='';getPlanList()">
            <el-option v-for="(item, index) in user" :label="item.advertiserName" :value="item.advertiserId" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放单元名称" prop="putUnitName" style="width: 500px">
          <el-input v-model="form.putUnitName"></el-input>
        </el-form-item>
        <el-form-item label="代码位类型" prop="slotType">
          <el-select :disabled="isModel===2" v-model="form.slotType">
            <el-option v-for="(item, index) in myOption.slotType" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代码位定向" prop="assignSlot" style="width: 500px">
          <el-input type="textarea" v-model="form.assignSlot" show-word-limit placeholder="多个用英文逗号隔开"></el-input>
        </el-form-item>
        <el-form-item label="媒体包名定向" prop="includePackages" style="width: 65vw" :class="{'is-error':packageInputError}">
          <el-tag size="mini" v-for="(tag, index) in includePackageArray" :key="index" closable :disable-transitions="false" @close="removePackage(tag)">{{tag}}</el-tag>
          <el-input class="input-new-tag" style="width: 180px" v-if="packageInputVisible" v-model="packageInputValue" ref="packageInputRef" size="small" placeholder="com.huawei.appmarket" @keyup.enter.native="handlePackageInputConfirm" @blur="handlePackageInputConfirm"></el-input>
          <el-button v-else class="button-new-tag" size="small" icon="el-icon-plus" @click="showPackageInput"></el-button>
          <el-tooltip effect="light" content="包名：支持字母、数字、下划线、点号。不支持数字开头, 且至少要满足格式：xxx.yyy" placement="right"><i class="el-icon-info"></i></el-tooltip>
        </el-form-item>
        <el-form-item label="品牌定向" prop="includeBrands" style="width: 65vw" :class="{'is-error':brandInputError}">
          <el-tag size="mini" v-for="(tag, index) in includeBrandArray" :key="index" closable :disable-transitions="false" @close="removeBrand(tag)">{{tag}}</el-tag>
          <el-input class="input-new-tag" v-if="brandInputVisible" v-model="brandInputValue" ref="brandInputRef" size="small" placeholder="HUAWEI" @keyup.enter.native="handleBrandInputConfirm" @blur="handleBrandInputConfirm"></el-input>
          <el-button v-else class="button-new-tag" size="small" icon="el-icon-plus" @click="showBrandInput"></el-button>
          <el-tooltip effect="light" content="品牌：支持字母、数字、下划线、中划线、空格。不支持数字开头" placement="right"><i class="el-icon-info"></i></el-tooltip>
        </el-form-item>
        <el-form-item label="机型定向" prop="includeModels" style="width: 65vw" :class="{'is-error':modelInputError}">
          <el-tag size="mini" v-for="(tag, index) in includeModelArray" :key="index" closable :disable-transitions="false" @close="removeModel(tag)">{{tag}}</el-tag>
          <el-input class="input-new-tag" v-if="modelInputVisible" v-model="modelInputValue" ref="modelInputRef" size="small" placeholder="Mate 30 Pro" @keyup.enter.native="handleModelInputConfirm" @blur="handleModelInputConfirm"></el-input>
          <el-button v-else class="button-new-tag" size="small" icon="el-icon-plus" @click="showModelInput"></el-button>
          <el-tooltip effect="light" content="机型：支持字母、数字、下划线、中划线、空格。" placement="right"><i class="el-icon-info"></i></el-tooltip>
        </el-form-item>
        <el-form-item label="投放计划" prop="planId">
          <el-select v-model="form.planId">
            <el-option v-for="(item, index) in planData" :label="item.planName" :value="item.planId" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="流量类型" prop="flowType">
          <el-select v-model="form.flowType">
            <el-option v-for="(item, index) in myOption.flowType" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="控制频次" prop="isLimit">
          <el-select v-model="form.isLimit">
            <el-option v-for="(item, index) in isLimitData" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="form.isLimit !== 0">
          <el-form-item label="每人每天看到X次后不再展现" prop="showLimit" style="width: 500px">
            <el-input type="text" v-model="form.showLimit" show-word-limit @input="integer($event, 'showLimit')"></el-input>
          </el-form-item>
          <el-form-item label="每人每天点击X次后不再展现" prop="clickLimit" style="width: 500px">
            <el-input type="text" v-model="form.clickLimit" show-word-limit @input="integer($event, 'clickLimit')"></el-input>
          </el-form-item>
        </template>
        <el-form-item label="应用广告只下发已安装用户" prop="assignInstallPkg">
          <el-switch v-model="form.assignInstallPkg" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="应用广告只下发未安装用户" prop="assignUninstallPkg">
          <el-switch v-model="form.assignUninstallPkg" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="备注" prop="remark" style="width: 500px">
          <el-input type="textarea" v-model="form.remark" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">提交</el-button>
          <el-button v-if="isModel!==2" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Edit',
  data () {
    let putUnitNameRule = (rule, value, callback) => {
      if (this.isSspUser && this.form.advertiserId === '') {
        callback(new Error('请先选择所属广告主'))
      } else {
        if (value === '') {
          callback(new Error('请输入投放单元名称'))
        } else {
          if (value.length < 1 || value.length > 100) {
            callback(new Error('长度在 1 到 100 个字符'))
          } else {
            if (this.isModel !== 2 || this.oldName !== value) {
              this.$axios({
                method: 'post',
                headers: {
                  'Authorization': this.$store.state.user.token,
                  'ModuleId': this.thisModule.id
                },
                url: this.myOption.requestUrl + this.thisModule.exists,
                data: this.qs.stringify({
                  advertiserId: this.form.advertiserId,
                  putUnitName: value
                })
              }).then((res) => {
                let code = res.data.code
                if (code === 200) {
                  if (res.data.data.exists) {
                    callback(new Error('投放单元名称已存在'))
                  } else {
                    callback()
                  }
                } else {
                  this.myOption.abnormalCode(this, code)
                }
              }).catch((err) => {
                this.myOption.abnormalCode(this, err)
              })
            } else {
              callback()
            }
          }
        }
      }
    }
    return {
      id: '',
      title: '',
      user: [],
      planData: [],
      oldName: '',
      thisModule: {},
      isSspUser: this.$store.getters.isMediaOwner,
      isModel: this.$store.getters.isEditId,
      isLoading: false,
      isShow: false,
      form: {
        putUnitName: '',
        slotType: 1,
        planId: '',
        remark: '',
        advertiserId: '',
        assignSlot: '',
        isLimit: 0,
        flowType: '',
        showLimit: '',
        clickLimit: '',
        assignInstallPkg: 0,
        assignUninstallPkg: 0
      },

      includePackageArray: [],
      packageInputVisible: false,
      packageInputValue: '',
      packageInputError: false,

      includeBrandArray: [],
      brandInputVisible: false,
      brandInputValue: '',
      brandInputError: false,

      includeModelArray: [],
      modelInputVisible: false,
      modelInputValue: '',
      modelInputError: false,

      isLimitData: [
        {id: 0, name: '不限制'},
        {id: 1, name: '启动控制'}
      ],
      rules: {
        putUnitName: [
          { required: true, validator: putUnitNameRule, trigger: 'blur' }
        ],
        slotType: [
          { required: true, message: '请选择代码位类型', trigger: 'change' }
        ],
        planId: [
          { required: true, message: '请选择投放计划', trigger: 'change' }
        ],
        flowType: [
          { required: true, message: '请选择流量类型', trigger: 'change' }
        ],
        showLimit: [
          { required: true, message: '请输入每人每天看到X次后不再展现', trigger: 'blur' }
        ],
        clickLimit: [
          { required: true, message: '请输入每人每天点击X次后不再展现', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (!this.isSspUser) {
      this.form.advertiserId = this.$store.state.user.info.advertiserId
    }
    let thisModule = this.myOption.requestModule.unit.children
    if (this.isModel === 2) {
      this.isLoading = true
      this.id = this.$store.state.user.editId
      this.title = '修改投放单元'
      this.thisModule = thisModule.modify
      this.thisModule.detail = thisModule.detail
      this.getDetail()
    } else {
      this.title = '新建投放单元'
      this.thisModule = thisModule.add
      if (this.isSspUser) {
        this.getUserList()
      }
      if (this.isModel === 3) {
        this.isLoading = true
        this.id = this.$store.state.user.editId
        this.thisModule.detail = thisModule.detail
        this.getDetail()
      }
    }
    if (!this.isSspUser) {
      this.getPlanList()
    }
  },
  methods: {
    validateTargetingInput (includeArray = [], inputValue, validateFn, cnName) {
      let maxLen = 30
      let maxSize = 20
      if (inputValue) {
        if (validateFn(inputValue)) {
          if (inputValue.length > maxLen) {
            return `${cnName}长度不能大于${maxLen}`
          } else if (includeArray.length >= maxSize) {
            return `${cnName}数量不能超过${maxSize}个`
          } else if (includeArray.some(s => s.toLowerCase() === inputValue.toLowerCase())) {
            return `${cnName}已存在！`
          }
        } else {
          return `${cnName}格式无效！`
        }
      }
      return ''
    },

    removePackage (pkg) {
      this.includePackageArray.splice(this.includePackageArray.indexOf(pkg), 1)
    },
    showPackageInput () {
      this.packageInputVisible = true
      this.$nextTick(_ => this.$refs.packageInputRef.$refs.input.focus())
    },
    handlePackageInputConfirm () {
      let errorTip = this.validateTargetingInput(this.includePackageArray, this.packageInputValue, this.$utils.validPackage, '包名')
      if (errorTip) {
        this.packageInputError = true
        this.$message.error(errorTip)
      } else {
        this.packageInputValue && this.includePackageArray.push(this.packageInputValue)
        this.packageInputVisible = false
        this.packageInputValue = ''
        this.packageInputError = false
      }
    },

    removeBrand (brand) {
      this.includeBrandArray.splice(this.includeBrandArray.indexOf(brand), 1)
    },
    showBrandInput () {
      this.brandInputVisible = true
      this.$nextTick(_ => this.$refs.brandInputRef.$refs.input.focus())
    },
    handleBrandInputConfirm () {
      let errorTip = this.validateTargetingInput(this.includeBrandArray, this.brandInputValue, this.$utils.validBrand, '品牌')
      if (errorTip) {
        this.brandInputError = true
        this.$message.error(errorTip)
      } else {
        this.brandInputValue && this.includeBrandArray.push(this.brandInputValue)
        this.brandInputVisible = false
        this.brandInputValue = ''
        this.brandInputError = false
      }
    },

    removeModel (model) {
      this.includeModelArray.splice(this.includeModelArray.indexOf(model), 1)
    },
    showModelInput () {
      this.modelInputVisible = true
      this.$nextTick(_ => this.$refs.modelInputRef.$refs.input.focus())
    },
    handleModelInputConfirm () {
      let errorTip = this.validateTargetingInput(this.includeModelArray, this.modelInputValue, this.$utils.validModel, '机型')
      if (errorTip) {
        this.modelInputError = true
        this.$message.error(errorTip)
      } else {
        this.modelInputValue && this.includeModelArray.push(this.modelInputValue)
        this.modelInputVisible = false
        this.modelInputValue = ''
        this.modelInputError = false
      }
    },

    close () {
      this.myOption.switchListAndEdit(this, true)
    },
    // 获取投放计划列表
    getPlanList () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.plan,
        data: this.qs.stringify({
          startPage: 1,
          pageSize: this.myOption.pageSize.max,
          advertiserId: this.form.advertiserId
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.planData = res.data.data.data
        } else {
          this.myOption.abnormalCode(this, code)
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
      })
    },
    // 获取广告主列表
    getUserList () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.user,
        data: this.qs.stringify({
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.user = res.data.data.data
        } else {
          this.myOption.abnormalCode(this, code)
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
      })
    },
    // 获取详情信息
    getDetail () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.detail.id
        },
        url: this.myOption.requestUrl + this.thisModule.detail.api,
        data: this.qs.stringify({
          putUnitId: this.id
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          let data = res.data.data
          if (this.isSspUser) {
            this.form.advertiserId = data.advertiserId
            this.getUserList()
            this.getPlanList()
          }
          this.form.putUnitName = data.putUnitName
          this.oldName = data.putUnitName
          this.form.slotType = data.slotType
          this.form.remark = data.remark
          this.form.planId = data.planInfoVo.planId
          this.form.assignSlot = data.assignSlot
          this.form.flowType = data.flowType
          this.form.isLimit = data.isLimit
          this.form.assignInstallPkg = data.assignInstallPkg
          this.form.assignUninstallPkg = data.assignUninstallPkg
          if (data.isLimit) {
            this.form.showLimit = data.showLimit
            this.form.clickLimit = data.clickLimit
          }

          this.includePackageArray = (data.includePackages || '').split(',').filter(Boolean)
          this.includeBrandArray = (data.includeBrands || '').split(',').filter(Boolean)
          this.includeModelArray = (data.includeModels || '').split(',').filter(Boolean)

          this.isLoading = false
        } else {
          this.myOption.abnormalCode(this, code)
          this.isLoading = false
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let param = {
            putUnitName: this.form.putUnitName,
            slotType: this.form.slotType,
            planId: this.form.planId,
            assignSlot: this.form.assignSlot,
            includePackages: this.includePackageArray.join(','),
            includeBrands: this.includeBrandArray.join(','),
            includeModels: this.includeModelArray.join(','),
            flowType: this.form.flowType,
            isLimit: this.form.isLimit,
            assignInstallPkg: this.form.assignInstallPkg,
            assignUninstallPkg: this.form.assignUninstallPkg,
            remark: this.form.remark
          }
          if (this.form.isLimit) {
            param.showLimit = this.form.showLimit
            param.clickLimit = this.form.clickLimit
          }
          if (this.isSspUser) {
            param.advertiserId = this.form.advertiserId
          }
          if (this.isModel === 2) {
            param.putUnitId = this.id
          }
          this.$axios({
            method: 'post',
            headers: {
              'Authorization': this.$store.state.user.token,
              'ModuleId': this.thisModule.id
            },
            url: this.myOption.requestUrl + this.thisModule.api,
            data: this.qs.stringify(param)
          }).then((res) => {
            let code = res.data.code
            this.isLoading = false
            if (code === 200) {
              this.$message.success(`${this.isModel === 2 ? '修改' : '新建'}投放单元成功`)
              this.$router.push({path: this.$route.path.replace('/edit', '/list')})
            } else {
              this.myOption.abnormalCode(this, code)
            }
          }).catch((err) => {
            this.isLoading = false
            this.myOption.abnormalCode(this, err)
          })
        } else {
          return false
        }
      })
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    // 整数
    integer (value, id) {
      if (!/(^[0]?$)|(^[1-9][0-9]*$)/g.test(value)) {
        if (!/(^[1-9]$)/g.test(value[0])) {
          this.form[id] = 0
        } else {
          this.form[id] = value.match(/[0-9]+/)[0]
        }
      }
    }
  },
  beforeDestroy () {
    this.$store.dispatch('SetEditId', false)
  }
}
</script>
<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 24px;
  line-height: 24px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 105px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/unit/Edit.vue